/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Property} from './Property';

/**
 * The InlineResponse2017 model module.
 * @module model/InlineResponse2017
 * @version 1.0.0
 */
export class InlineResponse2017 {
  /**
   * Constructs a new <code>InlineResponse2017</code>.
   * @alias module:model/InlineResponse2017
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse2017</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2017} obj Optional instance to populate.
   * @return {module:model/InlineResponse2017} The populated <code>InlineResponse2017</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2017();
      if (data.hasOwnProperty('data'))
        obj.data = Property.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/Property} data
 */
InlineResponse2017.prototype.data = undefined;

